module.exports = __webpack_public_path__ + "img/con1.55686a9d.png";